import { environment } from '../environments'
import { getExternalInterface } from '../services/external-interface'

export const getApiBaseUrl = () => environment().gotoApiBaseUrl

export const getJiveApiBaseUrl = () => environment().jiveApiBaseUrl

const getWebAuthUrlRedirectServiceBaseUrl = () =>
  `https://goto-desktop.goto.com/${getExternalInterface().isCompanion ? 'gotoforteams/' : ''}web/auth/`

export const getWebAuthRedirectUrlSignIn = () => `${getWebAuthUrlRedirectServiceBaseUrl()}sign-in.html`

export const getWebAuthRedirectUrlSignOut = () =>
  `${getWebAuthUrlRedirectServiceBaseUrl()}sign-out.html?signOutUrl=${encodeURIComponent(
    `${environment().authRedirectUrlContainerSignOut}=${encodeURIComponent(window.location.origin)}`,
  )}`

export const getExternalInterfacePorts = () => environment().externalInterfacePorts as number[]
